export interface HttpBaseData {
  errorCode: number;
  errorMessage: string | null;
}

export interface HttpBaseResponse {
  status: number;
  data: HttpBaseData;
}

const axiosUtil = {
  isSuccess: (res: HttpBaseResponse) => {
    if (res?.status === 200 && !res?.data?.errorCode && !res.data.errorMessage)
      return true;

    return false;
  },
};

export default axiosUtil;
